import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Alert, AlertType, PositiionType } from './toastr.type';
import { NavigationStart, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {
  private readonly router = inject(Router);
  public subject = new Subject<Alert>();
  public keepAfterRouteChange = false;

  constructor() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterRouteChange) {
          this.keepAfterRouteChange = false;
        } else {
          this.clear();
        }
      }
    });
  }
  success({ message, title, position, id, close, icon, delay }: { message: string, title?: string, position?: PositiionType, id?: string, close?: boolean, icon?: string, delay?: number }) {
    this.alert(new Alert({ title, message, type: AlertType.success, id, position: position, close, icon, delay }), true);
  }

  error({ message, title, position, id, close, icon, delay }: { message: string, title?: string, position?: PositiionType, id?: string, close?: boolean, icon?: string, delay?: number }) {
    this.alert(new Alert({ title, message, type: AlertType.error, id, position: position, close, icon, delay }), true);
  }

  info({ message, title, position, id, close, icon, delay }: { message: string, title?: string, position?: PositiionType, id?: string, close?: boolean, icon?: string, delay?: number }) {
    this.alert(new Alert({ title, message, type: AlertType.info, id, position: position, close, icon, delay }), true);
  }

  warning({ message, title, position, id, close, icon, delay }: { message: string, title?: string, position?: PositiionType, id?: string, close?: boolean, icon?: string, delay?: number }) {
    this.alert(new Alert({ title, message, type: AlertType.warning, id, position: position, close, icon, delay }), true);
  }

  default({ message, title, position, id, close, icon, delay }: { message: string, title?: string, position?: PositiionType, id?: string, close?: boolean, icon?: string, delay?: number }) {
    this.alert(new Alert({ title, message, type: AlertType.default, id, position: position, close, icon, delay }), true);
  }

  alert(alert: Alert, keepRouteChange: boolean) {
    this.keepAfterRouteChange = keepRouteChange;
    this.subject.next(alert);
  }
  clear(id?: string) {
    this.subject.next(new Alert({ id }));
  }
}
